import type { Route } from '@angular/router';
import { defaultPageOptions } from 'src/app/core/models';
import { dotPathCanActivateGuard } from '../../shared/dot-path.guard';

export const contentfulAdminRoutes: Route[] = [
  {
    path: '.contentful-admin',
    canActivate: [dotPathCanActivateGuard],
    children: [
      {
        path: 'all-links',
        loadComponent: () =>
          import('./contentful-all-page-links/contentful-all-page-links.component').then(
            (m) => m.AppContentfulAllPageLinksComponent,
          ),
      },
    ],
    data: {
      page: defaultPageOptions,
    },
  },
];
